import { render, staticRenderFns } from "./SettingsSelection.vue?vue&type=template&id=57f0b857&scoped=true&"
import script from "./SettingsSelection.vue?vue&type=script&lang=js&"
export * from "./SettingsSelection.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSelection.vue?vue&type=style&index=0&id=57f0b857&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0b857",
  null
  
)

export default component.exports